import Quill from "quill";
const Inline = Quill.import("blots/inline");

class LongSentenceBlot extends Inline {
  static create(message) {
    const node = super.create();
    node.setAttribute("title", message || "Too long");
    return node;
  }

  static formats(node) {
    return node.getAttribute("title");
  }
}
LongSentenceBlot.blotName = "long-sentence";
LongSentenceBlot.tagName = "span";
LongSentenceBlot.className = "long-sentence";

Quill.register(LongSentenceBlot);
